import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

// Lazy load all pages for code splitting
const Index = lazy(() => import("./pages/Index"));
const Auth = lazy(() => import("./pages/Auth"));
const Ingressoscasarao = lazy(() => import("./pages/Ingressoscasarao"));
const AdminShows = lazy(() => import("./pages/AdminShows"));
const SorteioCadastro = lazy(() => import("./pages/SorteioCadastro"));
const AdminSorteio = lazy(() => import("./pages/AdminSorteio"));
const AdminControleIngressos = lazy(() => import("./pages/AdminControleIngressos"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

// Minimal loading fallback
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
  </div>
);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/auth" element={<Auth />} />
              <Route path="/ingressoscasarao" element={<Ingressoscasarao />} />
              <Route path="/sorteio-cadastro" element={<SorteioCadastro />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Index />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/shows"
                element={
                  <ProtectedRoute>
                    <AdminShows />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/sorteio"
                element={
                  <ProtectedRoute>
                    <AdminSorteio />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/controle-ingressos"
                element={
                  <ProtectedRoute>
                    <AdminControleIngressos />
                  </ProtectedRoute>
                }
              />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
